module.exports = __webpack_public_path__ + "static/media/icon_09.c1fc58f6.png";